// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202605210357/js/" + chunkId + "." + {"44":"386c58d4","225":"2fa625e8","481":"4c1cdb8a","486":"6b150213","770":"f84a3444"}[chunkId] + ".0.2750582621476656.chunk.js";
};